import { Component } from '@angular/core';

@Component({
  selector: 'cx-login-page',
  templateUrl: './login-page.component.html',
  styles: ['./login-page.component']
})
export class LoginPageComponent {}
